import { all, takeLatest, put, call } from '@redux-saga/core/effects';
import Cookies from 'js-cookie';
import {
  VERIFY_VOUCHER_CODE_REQUEST,
  VERIFY_VOUCHER_CODE_FAILURE,
  VERIFY_VOUCHER_CODE_SUCCESS
} from '../actions/voucher.actions';
import { verifyVoucherCode } from './voucher.api';
import { VerifyVoucherSuccessPayloadSchema } from './voucher.schema';
import { TEACHER_ID, PREV_VOUCHER_CODE } from '../constants/storageKeys';

function* checkVoucherCode({ payload }) {
  try {
    const response = yield call(verifyVoucherCode, payload);

    if (response.status !== 200) {
      if (response.payload && response.payload.message) {
        Cookies.remove(PREV_VOUCHER_CODE);
        yield put(VERIFY_VOUCHER_CODE_FAILURE(response.payload.message));
      }
    } else if (yield VerifyVoucherSuccessPayloadSchema.isValid(response.payload)) {
      const { voucher } = response.payload;

      yield put(VERIFY_VOUCHER_CODE_SUCCESS(voucher));
      Cookies.set(PREV_VOUCHER_CODE, payload);
      if (voucher.teacherId) {
        window.localStorage.setItem(TEACHER_ID, voucher.teacherId);
      }
    } else {
      yield put(VERIFY_VOUCHER_CODE_FAILURE(null));
      Cookies.remove(PREV_VOUCHER_CODE);
      // TODO handle invalid schema
    }
  } catch (e) {
    yield put(VERIFY_VOUCHER_CODE_FAILURE(e));
    Cookies.remove(VERIFY_VOUCHER_CODE_REQUEST);
  }
}

function* voucherSaga() {
  yield all([takeLatest(VERIFY_VOUCHER_CODE_REQUEST, checkVoucherCode)]);
}

export default voucherSaga;
